// JsFromRoutes CacheKey a38509b08edd6f7f8fddd3a68b53d606
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@corp/services/api'

export default {
  search: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/multi_place_gifts/search'),
  copy: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/multi_place_gifts/:id/copy'),
  updateGiftTags: /* #__PURE__ */ definePathHelper('put', '/admin/consumer/multi_place_gifts/:id/gift_tags'),
  typeahead: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/multi_place_gifts/typeahead'),
  index: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/multi_place_gifts'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/admin/consumer/multi_place_gifts/:id'),
}
